/**
 * 单飞原语 —— 同一时刻只允许一个调用在飞，其余排队等**同一个**结果。
 *
 * 单独抽出来是因为它值得被单独测：access 令牌 5 分钟过期(契约 §8.4)，
 * 并发请求同时撞到过期是常态，刷 N 次会把 refresh 的滑动续期打乱。
 */
export function singleFlight<T>(fn: () => Promise<T>): () => Promise<T> {
  let inFlight: Promise<T> | null = null

  return () => {
    // ⚠ 已经有一个在飞就直接返回它 —— 排队的人拿到的是同一个 promise，
    //   于是「只刷一次」和「所有人拿到同一个终态」这两件事同时成立。
    if (inFlight) return inFlight

    const run = fn().finally(() => {
      inFlight = null
    })
    inFlight = run
    return run
  }
}
